import { allQuicksightDashboardAccount } from '../queries';
import { useQuery } from 'react-apollo';
import { removeConnectionsMemoized } from '../';

export function useAllQuicksightDashboardAccount () {
  const { data: query , refetch: refresh, loading: isLoading } = useQuery(allQuicksightDashboardAccount, {
    fetchPolicy: 'cache-first',
  });
  const data = (query?.allQuicksightDashboardAccount?.edges.length) > 0 ? [{
    dbId: 0,
    name: 'Select a dashboard',
    awsId: null,
  }, ...removeConnectionsMemoized(query?.allQuicksightDashboardAccount)] : [];
  //const dashboard = data.map(({dbId, name, awsId, information}) => ({ dbId, name, awsId}))
  return {
    data,
    refresh,
    isLoading
  };
}
